import React from "react";
import {formatDateTime} from "./Utils";

export default function Audit({auditCreateUser, auditModifyUser}) {

  return (
    <p style={{
      fontSize: '12px'
    }}>
      {auditCreateUser && auditCreateUser.createDate && <><b>Created on</b> {formatDateTime(auditCreateUser.createDate)}
        {auditCreateUser.createUser && <> by {auditCreateUser.createUser.firstName + ' ' + auditCreateUser?.createUser.lastName} </>}
        <br/></>}
      {auditModifyUser && auditModifyUser.modifyDate && <><b>Last updated</b> {formatDateTime(auditModifyUser.modifyDate)}
        {auditModifyUser.modifyUser && <> by {auditModifyUser.modifyUser.firstName + ' ' + auditModifyUser?.modifyUser.lastName}</>}
      </>}
    </p>
  );

}